<script lang="ts">
    import { login } from "../../../store"
    import { _ } from "svelte-i18n"
    export let account: Account
    $: personalAccount = $login.account.ident.personNumber
</script>

{#if account.ident.personNumber === personalAccount}
    <span class="badge badge-primary">{$_("followUp.onMyList")}</span>
{:else}
    <span>{account.firstname} {account.lastname} ({account.ident.personNumber})</span>
{/if}
